(function () {
  'use strict';

  /* @ngdoc object
   * @name crewWaterConsumption
   * @description
   *
   */
  angular
    .module('crewWaterConsumption', [
      'ui.router'
    ]);
}());
